import { FormTab, Group, GroupTitle } from "ra-friendsofbabba";

import FutureActionsField from "../fields/FutureActionsField";
import HelpAlert from "../HelpAlert";
import { Input } from "../../component/input";
import ResultsImpactField from "../fields/ResultsImpactField";
import { useTranslate } from "react-admin";

const Section5Tab = ({ reportType, ...props }) => {
  const translate = useTranslate();
  return (
    <FormTab {...props} label="resources.technical-reports.tabs.section_5">
      <Group wrapper>
        <GroupTitle
          title={translate("resources.technical-reports.title.section_5")}
        />
      </Group>

      <Input
        source="results_impact"
        fullWidth
        component={<ResultsImpactField />}
      />
      <Input
        source="future_actions"
        fullWidth
        component={<FutureActionsField />}
      />
      {reportType > 2 && <HelpAlert />}
    </FormTab>
  );
};

export default Section5Tab;
